import { useState, useEffect } from "react";
import { fetchMailMergedContent } from "../../../../network/service";
import { fetchLeadIdFromURL, hasMailMerge } from "../../../../utils/helpers";
import { RESPONSE_STATUS } from "../../../../utils/constants";

const fetchMailMergeContent = async (url, setMailMergeContent) => {
  const mailMergeMatches = hasMailMerge(url);
  if (!mailMergeMatches) {
    setMailMergeContent({
      responseStatus: RESPONSE_STATUS.requestFullfilled,
      response: url,
    });
    return;
  }
  const body = {
    data: url,
    leadId: fetchLeadIdFromURL(),
  };
  setMailMergeContent({
    responseStatus: RESPONSE_STATUS.requestPending,
  });
  try {
    const response = await fetchMailMergedContent(body);
    setMailMergeContent({
      responseStatus: RESPONSE_STATUS.requestFullfilled,
      response: response.data,
    });
  } catch (error) {
    console.log(error);
    setMailMergeContent({
      responseStatus: RESPONSE_STATUS.requestRejected,
    });
  }
};
const useMailMerge = (config) => {
  const [mailMergeContent, setMailMergeContent] = useState({
    responseStatus: RESPONSE_STATUS.requestPending,
  });

  const url = config?.url || "https://run.crm4b2c.com/a/HomeBuilder";
  useEffect(() => {
    fetchMailMergeContent(url, setMailMergeContent);
  }, [url]);
  return {
    url: mailMergeContent.response,
    loading: mailMergeContent.responseStatus === RESPONSE_STATUS.requestPending,
    error: mailMergeContent.responseStatus === RESPONSE_STATUS.requestRejected,
    initialize: () => {
      fetchMailMergeContent(url, setMailMergeContent);
    },
  };
};

export default useMailMerge;
